<template>
  <!-- 是否送礼 -->
  <el-dialog top="30vh" title="" :visible.sync="ticketPayDialog">
    <div class="first-gift">
      <img class="header-bg" src="@/assets/img/dialog/header-bg.png" alt="" />
      <img class="header" src="@/assets/img/dialog/header.png" alt="" />
      <img class="close" @click="toggleTicketPayDialog(false)" src="@/assets/img/dialog/close.png" alt="" />
      <img class="help" src="@/assets/img/dialog/help.png" alt="" title="做任务领取免费入场券" />
      <div class="row1">
        本直播间入场需要消耗<span>{{ ticketAnchor.ticket }}</span
        >张入场券
      </div>
      <div class="row2">
        当前剩余 <span>{{ ticket }}</span> 张入场券。
      </div>

      <div class="btn btn-active" @click="confirm">进入</div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig", "ticket", "ticketPayDialog", "ticketAnchor", "isNeedRefresh"]),
  },
  props: {},

  data() {
    return {};
  },
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    ...mapMutations(["toggleTicketPayDialog"]),

    confirm() {
      post({
        url: "/api/live/ticket",
        data: {
          uid: this.userInfo.id,
          anchor_id: this.ticketAnchor.anchorid,
        },
      })
        .then(({ data }) => {
          if (data.status === 0) {
            this.$message.success("支付成功");
            this.$router.push(`/liveMatchesTwo/${this.ticketAnchor.anchorid}`);
            this.toggleTicketPayDialog(false);
            if (this.isNeedRefresh) {
              window.location.reload();
            }
          }
        })
        .catch((err) => console.log("err", err));
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog {
    width: 3.7rem;
    border-radius: 0.16rem;
  }
}
.header {
  height: 0.57rem;
  position: absolute;
  top: -0.14rem;
}
.header-bg {
  height: 2rem;
  position: absolute;
  top: -2rem;
  z-index: -1;
}
.close {
  position: absolute;
  width: 0.32rem;
  bottom: -0.56rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  cursor: pointer;
}
.help {
  position: absolute;
  width: 0.24rem;
  top: 0.12rem;
  right: 0.12rem;
}
.first-gift {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.2rem;
  .row1 {
    color: #333333;
    font-size: 0.18rem;
    margin-top: 0.45rem;
    span {
      color: #02a8a2;
    }
  }
  .row2 {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666666;
    font-size: 0.15rem;
    cursor: pointer;
    margin-top: 0.1rem;
    span {
      color: #02a8a2;
    }
  }
  .btn {
    width: 100%;
    height: 0.48rem;
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    box-shadow: 0px 4px 8px rgba(48, 185, 188, 0.2);
    border-radius: 6px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 0.4rem;
    margin-bottom: 0.1rem;
    font-size: 0.16rem;
  }
}
</style>
